export default "__VITE_ASSET__BsTb3bDz__"